import { ContentStatus } from "./content";

export const ContentSets=function(props:{isLoggedIn:boolean, isContentSetNew:boolean, contentStatus:ContentStatus, userContentList:string[], contentSetClick:Function, newSetClick:Function}){
    
    if(props.isLoggedIn===false)return null;
    if(props.userContentList.length===0)return null;

    let statusMsg='';
    if(props.contentStatus===ContentStatus.GetList)statusMsg="Loading ...";
    if(props.contentStatus===ContentStatus.GetListError)statusMsg="Error - Failed to load content list.  Try refresing browser.";
    if(statusMsg!=='')return <p className="teachers-statusmessage">{statusMsg}</p>

    let mySets=props.userContentList.map((contentSet:string, index:number)=>{
        let cleanContentSet=contentSet.replace(/_/g, ' ');
        return <li key={contentSet+'-'+index} onClick={()=>{props.contentSetClick(contentSet);}} >{cleanContentSet}</li>
    });

    let showNewButton=props.isContentSetNew===false;

    return(
        <>
            <hr />
            <h3>Your content</h3>
            {/* {props.userContentList.length>0&&<p>Click on a set to view and modify.</p>} */}
            <ul className='teachers-usercontent-list'>
                {mySets}
            </ul>
            {showNewButton&&<button onClick={()=>{props.newSetClick();}} className='teachers-contentview-newbutton teachers-button'>New Set</button>}
        </>
    )
};